import { useMsal } from '@azure/msal-react';

const globalAdminRole = 'superuser';
const localAdminRole = 'localadministrator';

const separatorBetweenRoleAndCountry = '.';
const countryIndex = 1;

export const useAdminRole = () => {
    const { accounts } = useMsal();
    const roles = accounts?.[0]?.idTokenClaims?.roles ?? [];

    const isGlobalAdmin = roles.some((role) => role.toLowerCase() === globalAdminRole);

    const countriesForLocalAdmin = roles
        .filter((role) => role.toLowerCase().startsWith(localAdminRole))
        .map((role) => role.split(separatorBetweenRoleAndCountry)[countryIndex]);
    const isLocalAdmin = countriesForLocalAdmin.length > 0;

    return {
        isGlobalAdmin,
        isLocalAdmin,
        countriesForLocalAdmin,
    };
};
